import {endpoints} from '@kapitalist/contract/endpoints'
import type {
  TPathPiecesOf,
  TRequestOf,
  TResponseOf,
} from '@kapitalist/contract/endpoints/types'
import {mkGameId, type TFormError} from '@kapitalist/contract/types'
import {GetApi} from '~/api/client'
import {playersMock} from '~/api/endpoints/game/GetGameData/mock'

const endpoint = endpoints.pregame.gameWaitingRoom

type Params = TRequestOf<typeof endpoint>
type PathPieces = TPathPiecesOf<typeof endpoint>
type Response = TResponseOf<typeof endpoint>

/**
 * Polled to get the latest status of the waiting room a player is waiting in before the game starts.
 */
export default class GetWaitingRoomData extends GetApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  // so the mocks can gradually increase the number of players in the response
  private static mockPlayerCount = 1
  public static resetMockPlayerCount() {
    this.mockPlayerCount = 1
  }

  protected mockRequestFailure(
    params: Params,
    pathPieces: PathPieces
  ): TFormError | null {
    if (pathPieces.maybeGameId === 'fail') {
      return {errors: {gameId: [`That game doesn't exist.`]}}
    }

    // return super.mockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(params: Params, pathPieces: PathPieces): Response {
    return {
      gameId: mkGameId(pathPieces.maybeGameId),
      status: 'waiting',
      players: playersMock.slice(0, GetWaitingRoomData.mockPlayerCount++),
      hostPlayerId: playersMock[0].playerId,
    }
  }

  protected transformResponse(r: Response) {
    return r
  }
}
